import React from "react";
import { AlertTriangle, X } from "lucide-react";

const ConfirmationAlert = ({
  show,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  type = "warning",
}) => {
  if (!show) return null;

  const styles = {
    warning: {
      border: "border-yellow-400",
      icon: <AlertTriangle className="text-yellow-500" size={22} />,
      btn: "bg-yellow-500 hover:bg-yellow-600",
    },
    danger: {
      border: "border-red-400",
      icon: <AlertTriangle className="text-red-500" size={22} />,
      btn: "bg-red-500 hover:bg-red-600",
    },
  };

  const style = styles[type] || styles.warning;

  return (
    <>
      {/* Background */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-[1px] z-40"
        onClick={onCancel}  
      />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in">
        <div
          className={`bg-white border ${style.border} rounded-lg shadow-xl w-full max-w-md overflow-hidden`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center gap-3 px-5 py-4 border-b">
            {style.icon}
            <h3 className="text-base font-semibold text-gray-800">
              {title}
            </h3>

            <button
              type="button"
              onClick={onCancel}
              className="ml-auto text-gray-400 hover:text-gray-600"
            >
              <X size={18} />
            </button>
          </div>

          {/* Body */}
          <div className="px-5 py-4 text-sm text-gray-700">
            {message}
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-3 px-5 py-4 bg-gray-50">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 rounded-md border text-gray-700 hover:bg-gray-100"
            >
              {cancelText}
            </button>

            <button
              type="button"
              onClick={() => onConfirm && onConfirm()} 
              className={`px-4 py-2 rounded-md text-white ${style.btn}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
    </>
  );
};

export default ConfirmationAlert;
